import { ZillowForAgentsLayout } from '@zillow/zrs-cms';
import React from 'react';

import ContentTemplate from '../../components/ContentTemplate';
import LayoutWrapper from '../../components/LayoutWrapper';
import {
    buildPrimaryPostPage,
    LayoutComponentProps,
} from '../../util/buildPrimaryPostPage';

export const Layout: React.FC<LayoutComponentProps> = (props) => {
    return (
        <LayoutWrapper
            {...props}
            LayoutComponent={ZillowForAgentsLayout}
            defaultTitle="Zillow Agents"
            knotchAccountId={
                process.env.NEXT_PUBLIC_KNOTCH_PA_LAYOUT_ACCOUNT_ID
            }
        />
    );
};

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'AGENTS',
        basePath: '/agents',
        useBasePathForId: true,
        ContentComponent: ContentTemplate,
        LayoutComponent: Layout,
        knotchAccountId: process.env.NEXT_PUBLIC_KNOTCH_PA_LAYOUT_ACCOUNT_ID,
        contentType: 'B2C',
        menuPropName: 'submenu',
        hasStickyNav: true,
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
